<template>
    <div>
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
    data() {
        return {};
    },
    created() {
        this.userAgent();
        this.windows_size();
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windows_size();
            })();
        };
    },
    methods: {
        windows_size() {
            localStorage.setItem("width", document.documentElement.clientWidth);
            localStorage.setItem("height", document.documentElement.clientHeight);
        },
        userAgent() {
            //获取访问的设备类型
            const userAgent =
                navigator.userAgent || navigator.vendor || window.opera;
            this.isMobile =
                /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
                    userAgent
                );
            if (this.isMobile == true) {
                localStorage.setItem("userAgent", "mobile"); //设置当前访问设备：移动端
            } else {
                localStorage.setItem("userAgent", "web"); //设置当前访问设备：电脑端
            }
        },
    },
};
</script>

<style lang="less">
@import url("../src/assets/css/base.less");
</style>


// WEBPACK FOOTER //
// src/App.vue